var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"splash-screen"}},[_c('v-icon',{staticStyle:{"color":"#a0a0a0","opacity":"0.5"},attrs:{"name":"sync","scale":"4","spin":""}}),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"15px","color":"#a0a0a0","font-size":"2em"}},[_vm._v(_vm._s(_vm.action))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }